<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>詢問紀錄
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <p class="my-3">&nbsp;</p>

        <div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-8 px-4">
                <div class="mb-5">
                  <div
                    class="mb-3 h5 font-weight-bold d-flex align-items-center"
                  >
                    <div>
                      <img
                        src="@/assets/images/comment.png"
                        width="26px"
                        alt=""
                        class="mr-2 mt-2"
                      />
                    </div>
                    <div>詢問内容</div>
                  </div>
                  <textarea
                    class="form-control"
                    id="validationTextarea"
                    placeholder=""
                    disabled
                    rows="4"
                    v-model="replyinquiryData.InquiryMessage"
                  ></textarea>
                  <p class="text-right mt-1">
                    詢問日期 : {{ replyinquiryData.CreateTime }}
                  </p>
                </div>

                <div class="mb-5">
                  <div
                    class="mb-2 h5 font-weight-bold d-flex align-items-center"
                  >
                    <div>
                      <img
                        src="@/assets/images/writing.png"
                        width="26px"
                        class="mr-2 mt-2"
                        alt=""
                      />
                    </div>
                    <div>回覆內容</div>
                  </div>
                  <textarea
                    class="form-control"
                    id="validationTextarea"
                    placeholder=""
                    rows="4"
                    v-model="replyinquiryData.ReplyMessage"
                  ></textarea>
                  <p class="text-right mt-1" v-if="replyinquiryData.ReplyTime">
                    回覆日期 :
                    {{ replyinquiryData.ReplyTime }}
                  </p>
                </div>

                <div class="d-flex" v-if="replyinquiryData.ProID > 0">
                  <p class="mr-3">是否顯示於產品問答？</p>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="Radios"
                      id="show"
                      :true-value="0"
                      v-model="replyinquiryData.Archived"
                      value="0"
                    />
                    <label class="form-check-label" for="show"> 是 </label>
                  </div>
                  <div class="form-check ml-3">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="Radios"
                      id="hide"
                      :true-value="1"
                      v-model="replyinquiryData.Archived"
                      value="1"
                    />
                    <label class="form-check-label" for="hide"> 否 </label>
                  </div>
                </div>
                <div class="MbDevice" v-if="replyinquiryData.ProID > 0">
                  <hr />
                </div>

                <div class="PcDevice mb-5">
                  <div class="d-flex justify-content-end mt-4">
                    <div
                      class="btn btn-lg btn-primary mr-3"
                      @click.prevent="addResponse"
                    >
                      確定送出
                    </div>
                    <div
                      class="btn btn-lg btn-secondary"
                      @click.prevent="backInquiryPage"
                    >
                      上一頁
                    </div>
                  </div>
                </div>

                <div class="MbDevice mb-5">
                  <div class="d-flex justify-content-center mt-4">
                    <div
                      class="btn btn-primary mr-3"
                      @click.prevent="addResponse"
                    >
                      確定送出
                    </div>
                    <div
                      class="btn btn-secondary"
                      @click.prevent="backInquiryPage"
                    >
                      上一頁
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 px-4 lineBottom">
                <div
                  class="h5 mb-3 text-center font-weight-bold d-flex align-items-center"
                >
                  <div>
                    <img
                      src="@/assets/images/id-card.png"
                      width="32px"
                      class="mt-1 mr-2"
                    />
                  </div>
                  <div>留言者資訊</div>
                </div>
                <table class="table">
                  <tbody>
                    <tr>
                      <th width="200">姓名</th>
                      <td>{{ replyinquiryData.InquiryName }}</td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{{ replyinquiryData.InquiryEmail }}</td>
                    </tr>
                    <tr>
                      <th>聯絡電話</th>
                      <td>{{ replyinquiryData.InquiryTel }}</td>
                    </tr>
                    <tr>
                      <th>手機</th>
                      <td>{{ replyinquiryData.InquiryMobile }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "詢問記錄 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      checked: true,
      value: true,
      RegNo: "",
      inquiry: [],
      PageSize: 1,
      inquiryID: "",
      inquiryList: [],
      replyinquiryData: [],
      totalPage: "",
      totalNo: "",
      currentPage: 1,
      ReplyMessage: "",
      show: false,
      inquiryRawData: [], //rawData
      totaltenPageNum: "", //共幾筆十頁
      tenPageNum: "",
      showpage: [],

      CSRF_Token: "",
      analyticData: false,
      replyStatus: "all",
      hasReply: "",
      ModalData: [],
      CompanyName: "",
      eComName: "",
      BoothNo: "",

      ProductData: [],

      SelectCat: "",
      ProductCategory: [],
      lang: "tw",
      newsUpdateTime: "",
    };
  },

  methods: {
    SwitchReStatus(status) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=1&replyStatus=${status}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=1&replyStatus=${status}`;
      }
    },

    getPage(page) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${page}&replyStatus=${vm.replyStatus}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${page}&replyStatus=${vm.replyStatus}`;
      }
    },

    nextPage() {
      const vm = this;
      let nextP = Number(vm.currentPage) + 1;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${nextP}&replyStatus=${vm.replyStatus}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${nextP}&replyStatus=${vm.replyStatus}`;
      }
    },

    lastPage() {
      const vm = this;
      let lastP = Number(vm.currentPage) - 1;

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${lastP}&replyStatus=${vm.replyStatus}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${lastP}&replyStatus=${vm.replyStatus}`;
      }
    },

    nexttenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum + 1;
      vm.showpage = vm.inquiryRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`;
      }
    },

    returntenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum - 1;
      vm.showpage = vm.inquiryRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}&page=${vm.currentPage}&replyStatus=${vm.replyStatus}`;
      }
    },

    editorBtn(id) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiryEditor?no=${vm.RegNo}&id=${id}`;
      } else if (vm.lang == "en") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiryEditor?no=${vm.RegNo}&id=${id}`;
      }
    },

    backInquiryPage() {
      const vm = this;

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`;
      } else if (vm.lang == "en") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`;
      }
    },

    //新增回覆內容
    addResponse() {
      const vm = this;

      let url = `/apiExhibitors/Inquiry/${vm.RegNo}/${vm.inquiryID}`;
      let info = {
        ReplyMessage: vm.replyinquiryData.ReplyMessage,
        Archived: vm.replyinquiryData.Archived,
        CSRF: vm.CSRF_Token,
      };

      if (!vm.replyinquiryData.ReplyMessage) {
        alert("您尚未回覆訊息！");
        return false;
      } else {
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("成功送出回覆訊息！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`;
          } else if (response.data.Code == 251) {
            alert("系統忙碌，請稍後再試！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 500) {
            alert("系統忙碌，請稍後再試！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`;
          }
        });
      }
    },

    addEnResponse() {
      const vm = this;

      let url = `/apiExhibitors/Inquiry/${vm.RegNo}/${vm.inquiryID}`;
      let info = {
        ReplyMessage: vm.replyinquiryData.ReplyMessage,
        Archived: vm.replyinquiryData.Archived,
        CSRF: vm.CSRF_Token,
      };

      if (!vm.replyinquiryData.ReplyMessage) {
        alert("You have not replied to the message");
        return false;
      } else {
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert("Successfully reply to message.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`;
          } else if (response.data.Code == 251) {
            alert("System is busy, please try again later.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 500) {
            alert("System is busy, please try again later.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/inquiry?no=${vm.RegNo}`;
          }
        });
      }
    },

    //新聞稿來源

    showNewsModal(id) {
      const vm = this;
      let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${id}`;
      axios.get(url).then(function (response) {
        vm.ModalData = response.data.Data;

        if (vm.ModalData !== null) {
          vm.newsUpdateTime = response.data.Data.UpdateTime.split(" ")[0];
          $('#openNewsModal a[href="#nav-cn-news"]').tab("show");
          $("#openNewsModal").modal("show");
        } else {
          alert("此篇新聞稿來源已不存在！");
        }
      });
    },

    showProModal(id) {
      const vm = this;

      let url = `/apiExhibitors/Product/${vm.RegNo}/${id}`;
      axios.get(url).then(function (response) {
        // console.log(response.data.Data)
        vm.ProductData = response.data.Data;

        if (vm.ProductData !== null) {
          //核對產品類別，取得已選的類別
          vm.SelectCat = vm.ProductCategory.find((item) => {
            return item.MainCategoryId == vm.ProductData.CatNo;
          });
          $('#openProModal a[href="#nav-cn-pro"]').tab("show");
          $("#openProModal").modal("show");
        } else {
          alert("此筆產品來源已不存在！");
        }
      });
    },

    showEnNewsModal(id) {
      const vm = this;
      let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${id}`;
      axios.get(url).then(function (response) {
        // console.log(response.data.Data)
        vm.ModalData = response.data.Data;

        if (response.data.Data == null) {
          alert("The source of this news no longer exists.");
        } else {
          vm.newsUpdateTime = response.data.Data.UpdateTime.split(" ")[0];
          $('#openNewsModal a[href="#nav-en-news"]').tab("show");
          $("#openNewsModal").modal("show");
        }
      });
    },

    showEnProModal(id) {
      const vm = this;

      let url = `/apiExhibitors/Product/${vm.RegNo}/${id}`;
      axios.get(url).then(function (response) {
        // console.log(response.data.Data)
        vm.ProductData = response.data.Data;

        if (vm.ProductData !== null) {
          //核對產品類別，取得已選的類別
          vm.SelectCat = vm.ProductCategory.find((item) => {
            return item.CatNo == vm.ProductData.CatNo;
          });

          $('#openProModal a[href="#nav-en-pro"]').tab("show");
          $("#openProModal").modal("show");
        } else {
          alert("The source of this product no longer exists");
        }
      });
    },

    CloseNewsModal() {
      const vm = this;
      $("#openNewsModal").on("hide.bs.modal", function () {
        vm.ModalData = [];
      });
      $("#openNewsModal").modal("hide");
    },

    CloseProModal() {
      const vm = this;
      $("#openProModal").on("hide.bs.modal", function () {
        vm.ProductData = [];
      });
      $("#openProModal").modal("hide");
    },
  },

  created() {
    const vm = this;

    //語系會自動抓html lang tag

    $(() => {
      $("#SliderTop").click(() => {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

      $(window)
        .scroll(function () {
          if ($(this).scrollTop() > 300) {
            $("#SliderTop").fadeIn(222);
          } else {
            $("#SliderTop").stop().fadeOut(222);
          }
        })
        .scroll();
    });

    //url取展碼
    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1].split("&")[0];

    vm.inquiryID = nowPage.split("id=")[1]; //取得單頁碼

    //判定有沒有page後面的replyStatus值
    vm.hasReply = nowPage.split("replyStatus=")[1];

    if (vm.hasReply) {
      vm.currentPage = nowPage.split("page=")[1].split("&")[0]; //取得頁數
      vm.replyStatus = nowPage.split("replyStatus=")[1]; //取得回覆狀態
      if (vm.replyStatus == "null") {
        vm.replyStatus = "all";
      }
    } else {
      vm.currentPage = nowPage.split("page=")[1];
    }

    //url取載入頁面名稱

    if (vm.lang == "tw") {
      var getHtmlurl = nowPage.split("/")[4];
      var HtmlName = getHtmlurl.split("?")[0];
    } else {
      //url取英文載入頁面參數
      var getEnHtmlurl = nowPage.split("/")[5];
      var HtmlEnName = getEnHtmlurl.split("?")[0];
    }

    // console.log(getHtmlurl)
    // console.log(HtmlName)

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //如果SS沒有資料，就將PAGE=1的訊息存入
    if (!vm.currentPage) {
      vm.currentPage = 1;
    }

    //新聞稿額度
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.CompanyName = response.data.Data.Company;
        vm.BoothNo = response.data.Data.BoothNo;
        vm.eComName = response.data.Data.Directory_eComName;
      });

    //取得產品類別列表
    let url2 = `/apiExhibitors/ProductCategory/${vm.RegNo}`;
    axios.get(url2).then(function (response) {
      vm.ProductCategory = response.data.Data.ProductMainCategory;
    });

    if (HtmlName == "inquiry" || HtmlEnName == "inquiry") {
      let url = `/apiExhibitors/Inquiry/${vm.RegNo}?Page=${vm.currentPage}&Reply=${vm.replyStatus}`;

      axios.get(url).then(function (response) {
        if (response.data.pagetotal > 0) {
          vm.inquiryList = response.data.Data;
          vm.totalPage = response.data.pagetotal;
          vm.totalNo = response.data.datatotal;

          for (let i = 0; i < vm.totalPage; i++) {
            if (i % 10 === 0) {
              vm.inquiryRawData.push([]);
            }

            const page = parseInt(i / 10); //parseInt整數公式
            vm.inquiryRawData[page].push(i + 1);
          }

          //totaltenPageNum 取得共有幾筆十頁
          vm.totaltenPageNum = vm.inquiryRawData.length;

          //從取得的筆數後，tenNum 計算出現第幾個十頁數

          let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

          vm.tenPageNum = parseInt(anaNowPage / 10);
          vm.showpage = vm.inquiryRawData[vm.tenPageNum];

          // vm.getlastpagenum()

          vm.show = true;
        } else {
          vm.show = false;
        }
      });
    } else if (HtmlName == "inquiryEditor" || HtmlEnName == "inquiryEditor") {
      let url2 = `/apiExhibitors/Inquiry/${vm.RegNo}/${vm.inquiryID}`;
      axios
        .get(url2)
        .then(function (response) {
          if (response.data.Data) {
            vm.replyinquiryData = response.data.Data;
          } else {
            alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`;
          }
        })
        .catch((err) => {
          alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/inquiry?no=${vm.RegNo}`;
        });
    }
  },
};
</script>

<style lang="scss">
.nav-link.active {
  color: #007bff !important;
  background-color: #ffffff !important;
}

.list-group-item {
  padding: 0.4rem 1rem;
}

.card-body {
  padding: 0.7rem;
}

.textOverflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.table thead th {
  border-bottom: 0px solid #dee2e6;
  padding: 15px;
}

.nav-tabs {
  border-bottom: 1px solid #eef2f7;
}
</style>
